import React from "react";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  ClientContractService,
  WorkflowService,
  WorkflowMessagesService,
} from "../../../services";
import { asyncStringToDateNoTimezone, changeFormatNumberToShow, getNavigatorTimezone } from "../../../utils";
import buttonsFollowUpContracts from "../../../utils/buttons-follow-up-contracts";
import { FollowUpActionsContractsView } from "../../views";
import { socket } from "../../../Context";

class followUpActionsContractsActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      user: {},
      token: "",
      shouldRefresh: false,
      message: " ",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      status: "",
      titleView: "",
      btn1: {},
      btn2: {},
      btn3: {},
      btn4: {},
      btn5: {},
      btn6: {},
      contract: {},
      workflowExecutionInfo: {},
      questions: [],
      path: "/",
      clientContractId: "",
      workflowExecutionId: "",
      errorMessage: "",
      lawyers: [],
      usersChat: {},
      conversation: [],
      membersChat: [],
      userHasPermission: true,
      userPermissionWorkflowArr: [],
      rolUserContraWrokflow: 0,
      selectedFile: null,
      errorFile: false,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      showAWS: true,
      contractIsPendingIn100505: false
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  clientContractService = new ClientContractService(this.url);
  workflowService = new WorkflowService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);

  workflowExecutionId = "";
  clientContractId = "";
  idAuthorMessage = 0;
  timezone = getNavigatorTimezone()

  async componentDidMount() {
    this.toggleLoadingRequesting(true);
    let urlArr = window.location.href.split("/");
    this.workflowExecutionId = urlArr[urlArr.length - 1].includes('?') ? urlArr[urlArr.length - 1].split('?')[0] : urlArr[urlArr.length - 1];
    this.clientContractId = urlArr[urlArr.length - 2];

    //call sockets    
    socket.on("messages", (data) => this.addNewMessageSocket(data));
    socket.emit("joinRoom", this.workflowExecutionId)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");

    this.getContarctData();
    this.getWorkExecutionId();
    this.getQuestionsForcontract();
    this.getLawers();
    this.getMessages();

    this.setState({
      loading: false,
      token: this.token,
      user: this.user,
    });
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function completed dialog

  toggleCompletedRequesting = (value, message) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion error dialog
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        errorMessage: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            errorMessage: "",
          });
        }, 4000);
      }
    );
  };

  //Funtion warning dialog
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showWarningRequesting: false,
            message: "",
          });
        }, 4000);
      }
    );
  };

  async getContarctData() {
    let clientContractId = this.clientContractId;
    // let clientContractId = 3
    this.setState({ clientContractId: clientContractId });
    try {
      let contract = await this.clientContractService.getContractById(
        clientContractId,
        this.token
      );
      if (contract && contract.data && Number(contract.statusCode) === 200) {
        this.setState({
          contract: contract.data,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        setTimeout(() => {
          this.toggleErrorRequesting();
        }, 3000);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      setTimeout(() => {
        this.toggleErrorRequesting();
      }, 3000);
    }
  }

  async getWorkExecutionId() {
    let workflowExecutionId = this.workflowExecutionId;
    this.setState({ workflowExecutionId: workflowExecutionId });
    try {
      let workflowExecution =
        await this.workflowService.getWorkFlowExecutionById(
          workflowExecutionId,
          this.token
        );
      if (
        workflowExecution &&
        workflowExecution.data &&
        Number(workflowExecution.statusCode) === 200
      ) {
        let statusCurrent =
          workflowExecution.data.workflowStatusDescriptions.statusCurrent
            .status;
        let currenteName =
          workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;
        let button1 = {};
        let button2 = {};
        let button3 = {};
        let button4 = {};
        let button5 = {};
        let button6 = {};
        let buttons = buttonsFollowUpContracts;

        if (
          statusCurrent ===
          Number(process.env.REACT_APP_STATUS_WORK_FLOW_100510)
        ) {
          button1 = buttons[0].btnsStatus100510.btn1;
          button3 = buttons[0].btnsStatus100510.btn3;
          button4 = buttons[0].btnsStatus100510.btn4;
          button5 = buttons[0].btnsStatus100510.btn5;
        } else if (
          statusCurrent ===
          Number(process.env.REACT_APP_STATUS_WORK_FLOW_100512)
        ) {
          button1 = buttons[0].btnsStatus100512.btn1;
          button3 = buttons[0].btnsStatus100512.btn3;
          button4 = buttons[0].btnsStatus100512.btn4;
          button5 = buttons[0].btnsStatus100512.btn5;
        } else if (
          statusCurrent ===
          Number(process.env.REACT_APP_STATUS_WORK_FLOW_100515)
        ) {
          button1 = buttons[0].btnsStatus100515.btn1;
          button3 = buttons[0].btnsStatus100515.btn3;
          button4 = buttons[0].btnsStatus100515.btn4;
          button5 = buttons[0].btnsStatus100515.btn5;
        } else if (
          Number(process.env.REACT_APP_STATUS_WORK_FLOW_100520) ||
          statusCurrent ===
          Number(process.env.REACT_APP_STATUS_WORK_FLOW_100522)
        ) {
          button1 = buttons[0].btnsStatus100520.btn1;
          button3 = buttons[0].btnsStatus100520.btn3;
          button4 = buttons[0].btnsStatus100520.btn4;
          button5 = buttons[0].btnsStatus100520.btn5;
        } else {
          button1 = buttons[0].btnsStatus100525.btn1;
          button3 = buttons[0].btnsStatus100525.btn3;
          button4 = buttons[0].btnsStatus100525.btn4;
          button5 = buttons[0].btnsStatus100525.btn5;
        }

        let rolesMember = workflowExecution.data.workflowExecutionMembers.filter((member) => member.email === this.user.userMetaData.userA3Cloud.email)
        let userPermissionWorkflowArr = JSON.parse(workflowExecution.data.workflowStatus.membersTypeAllowToShow)
        let allPermission = rolesMember.map(role => {
          let permissionUser = userPermissionWorkflowArr.includes(role.workflowExecutionMemberTypeId)
          return permissionUser
        })

        let permission = allPermission.includes(true) ? true : false
        let pendingContract = false
        if (workflowExecution.data && workflowExecution.data.workflowStatus && workflowExecution.data.workflowStatus.statusType && workflowExecution.data.workflowStatus.statusType === process.env.REACT_APP_STATUS_WORK_FLOW_100505_WAIT) {
          pendingContract = true
        }
        this.setState({
          workflowExecutionInfo: workflowExecution.data,
          titleView: currenteName,
          status: statusCurrent,
          btn1: button1,
          btn2: button2,
          btn3: button3,
          btn4: button4,
          btn5: button5,
          btn6: button6,
          userHasPermission: permission,
          contractIsPendingIn100505: pendingContract
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
          this.props.history.push("/");
        }, 3000);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      setTimeout(() => {
        this.toggleErrorRequesting();
        this.props.history.push("/");
      }, 3000);
    }
  }

  async getQuestionsForcontract() {
    let clientContractId = this.clientContractId;
    try {
      let questions = await this.clientContractService.getQuesitonsForContractById(clientContractId, this.token);
      if (questions && questions.data && Number(questions.statusCode) === 200) {
        let allQuestions = questions.data.map((question) => {
          let format = (question.formatVariable && question.formatVariable.groupName && question.formatVariable.groupName !== 'none') ? question.formatVariable.groupName : 'text'
          let value = ''
          if (format === 'number') {
            value = (question.answerNumber) ? changeFormatNumberToShow(question.answerNumber, question.formatVariable.id) : ''
          } else if (format === 'date') {
            value = question.answerDate
          } else {
            value = (question.answerString) ? question.answerString : ''
          }

          if (format === 'logic') {
            let questionLogic = {}
            questionLogic.truly = question.optionsLogic[0].name
            questionLogic.falsy = question.optionsLogic[1].name
            questionLogic.selectedLogic = question.optionsLogic[0].value ? true : false
            question.questionLogic = questionLogic
          }

          question.disabled = false
          question.isForContractor = true
          question.format = format
          question.value = value
          return question
        })

        this.setState({
          questions: allQuestions
        })
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
          this.props.history.push("/");
        }, 4000);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
        this.props.history.push("/");
      }, 4000);
    }
  }

  async getLawers() {
    let errorLawyers = "Error al consultar los abogados";
    let clientId =
      this.user && this.user.userMetaData
        ? this.user.userMetaData.userA3Cloud.clientId
        : "";
    try {
      let lawyersData = await this.clientContractService.getLawyersByClientId(
        clientId,
        this.token
      );
      if (
        lawyersData &&
        lawyersData.data &&
        Number(lawyersData.statusCode) === 200
      ) {
        this.setState({
          lawyers: lawyersData.data,
        });
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true, errorLawyers);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
          this.props.history.push("/");
        }, 3000);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true, errorLawyers);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
        this.props.history.push("/");
      }, 3000);
    }
  }

  getMessages = async () => {
    let errorMessages = "Ocurrió un error al consultar los mensajes";
    let user = {};
    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          this.workflowExecutionId,
          this.timezone,
          this.token
        );
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {
        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        );
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId;
          member.avatarUrl = member.profilePicture;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarAltText = member.firstName + " " + member.firstLastName;
          if (this.user.userMetaData.userA3Cloud.email === member.email) {
            this.idAuthorMessage = member.id;
            user = member;
          }
          return membersChat;
        });

        //Message chat
        workflowMessage.data.workflowExecutionMessages.map((member) => {
          member.author = {
            name: member.firstName + " " + member.firstLastName,
            id: member.workflowExecutionMemberId,
            avatarUrl: member.profilePicture,
          };
          let dateConvert = new Date(member.createdDate)
          member.timestamp = dateConvert
          member.text = member.workflowExecutionMemberMessage;
          member.id = member.workflowExecutionMemberId;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarUrl = member.profilePicture;
          if (member.workflowExecutionMemberMessageDoc.length > 0) {
            member.attachments = [
              {
                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
              },
            ];
          }
          return workflowMessage.data.workflowExecutionMessages;
        });
        this.setState({
          membersChat: membersChat,
          conversation: workflowMessage.data.workflowExecutionMessages,
          usersChat: user,
        });
        this.toggleLoadingRequesting(false);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true, errorMessages);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
          this.props.history.push("/");
        }, 3000);
      }
    } catch (error) {
      this.toggleErrorRequesting(true, errorMessages);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
        this.props.history.push("/");
      }, 3000);
    }
  };

  //Function to create message
  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData();
    data.append("workflowExecutionId", this.workflowExecutionId);
    data.append("workflowExecutionMemberId", this.idAuthorMessage);
    data.append("message", messagesChat.text);
    data.append("documento", fileContent);
    data.append("timezone", this.timezone)

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(
      data,
      this.token
    );
  };

  //add a new meessage to conversation when sockets send a mew message
  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation];
    let indexMessage = copyConversation.length;

    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,

      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    };
    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
    }

    copyConversation.push(newMessage);
    this.setState({
      conversation: copyConversation,
    });
  };

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  handleFile = async (e) => {
    // Upload the base64 in the state
    let fileBase64 = await this.pdfToBase64(e.target.files[0]);
    let pdfBase64 = fileBase64.split(",")[1];

    this.setState({
      selectedFile: e.target.files[0],
      selectedFileBase64: pdfBase64,
      selectedFileName: e?.target?.files[0]?.name,
      errorFile: false,
      colorBorderContainer: "green",
      showAWS: false
    });
  };

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      deletePfd: true,
      selectedFileBase64: "",
      colorBorderContainer: "gray",
      showAWS: true
    });
    return true;
  };

  renderComponentAgain = () => {
    this.getContarctData();
    this.getWorkExecutionId();
    this.getQuestionsForcontract();
    this.getLawers();
    this.getMessages();
  }


  cancelContract = async (status) => {
    this.toggleLoadingRequesting(true);
    let cancelError = 'Ocurrió un errror al cancelar el contrato'
    let workflowExecutionActionId = 5

    try {
      let cancelWorkflow = await this.workflowService.changeStatusWorkflow(this.workflowExecutionId, workflowExecutionActionId, this.token, status)
      if (cancelWorkflow && cancelWorkflow.data && Number(cancelWorkflow.statusCode) === 200) {
        this.toggleLoadingRequesting(false);
        this.toggleCompletedRequesting(true);
        setTimeout(() => {
          this.toggleCompletedRequesting(false);
          this.props.history.push("/")
        }, 4000);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true, cancelError);
        setTimeout(() => {
          this.toggleErrorRequesting(false);
        }, 4000);
      }
    } catch (error) {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true, cancelError);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
      }, 4000);
    }
  }

  render() {
    return (
      <FollowUpActionsContractsView
        showLoadingRequesting={this.showLoadingRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        showCompletedRequesting={this.showCompletedRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        showErrorRequesting={this.showErrorRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        path={this.state.path}
        createMessage={this.createMessage}
        handleDeleteFile={this.handleDeleteFile}
        handleFile={this.handleFile}
        renderComponentAgain={this.renderComponentAgain}
        cancelContract={this.cancelContract}
        {...this.state}
      />
    );
  }
}

export default withTranslation()(followUpActionsContractsActions);
